/*
    {
      title: "GRITIS",
      backgroundColor: "white",
      color: "darkblue",
      subItems: [{ title: "GRUPPO ITAL. ISOTOPI STABILI", url: "/gritis" }],
    },
*/

/*
  const menuItems = [
    {
      title: "ATTIVITÀ DSM",
      backgroundColor: "white",
      color: "darkblue",
      subItems: [
        { title: "Congressi e workshop", url: "/conferences_workshop" },
        { title: "Bandi e premi", url: "/calls_and_awards" },
        { title: "Annunci DSM", url: "/announcements_dsm" },
        { title: "Eventi con supporto DSM", url: "/dsm_supported_events" },
      ],
    },
    {
      title: "FORMAZIONE",
      backgroundColor: "white",
      color: "darkblue",
      subItems: [
        { title: "Scuole e corsi", url: "/schools_and_courses" },
        {
          title: "Scuole di formazione <br>pratico-applicative",
          url: "/training_schools",
        },
      ],
    },
    {
      title: "SPAZIO GIOVANI",
      backgroundColor: "white",
      color: "darkblue",
      subItems: [{ title: "Bacheca", url: "/youth_desk" }],
    },
    {
      title: "DSM",
      backgroundColor: "white",
      color: "darkblue",
      subItems: [
        { title: "Archivio DSM", url: "/dsm_archive" },
        { title: "DSM virtuale", url: "/virtual_resources" },
        { title: "Agenda DSM", url: "/dsm_diary" },
        { title: "Iscriversi", url: "/register_for_dsm" },
      ],
    },
    {
      title: "SPONSOR",
      backgroundColor: "white",
      color: "darkblue",
      subItems: [{ title: "Sponsor", url: "/sponsor" }],
    },
  ];
  */

import React from "react";
import translations from "./Translations.js";
import serverConfig from "./config";

const SecondaryMenu = ({ vertical = false }) => {
  const lang = (localStorage.getItem("language_dsm") || "IT").toUpperCase();
  const t = translations[lang];
  const menuItems = [
    {
      title: t.ATTIVITA_DSM,
      backgroundColor: "white",
      color: "darkblue",
      subItems: [
        { title: t.CONGRESSI, url: "/conferences_workshop" },
        { title: t.BANDI, url: "/calls_and_awards" },
        { title: t.ANNUNCI, url: "/announcements_dsm" },
        { title: t.EVENTI, url: "/dsm_supported_events" },
      ],
    },
    {
      title: t.FORMAZIONE,
      backgroundColor: "white",
      color: "darkblue",
      subItems: [
        { title: t.SCUOLE, url: "/schools_and_courses" },
        { title: t.SCUOLE_PRATICHE, url: "/training_schools" },
      ],
    },
    {
      title: t.SPAZIO_GIOVANI,
      backgroundColor: "white",
      color: "darkblue",
      subItems: [{ title: t.BACHECA, url: "/youth_desk" }],
    },
    {
      title: t.DSM,
      backgroundColor: "white",
      color: "darkblue",
      subItems: [
        { title: t.ARCHIVIO, url: "/dsm_archive" },
        { title: t.VIRTUALE, url: "/virtual_resources" },
        { title: t.AGENDA, url: "/dsm_diary" },
        { title: t.ISCRIVERSI, url: "/register_for_dsm" },
      ],
    },
    {
      title: t.SPONSOR,
      backgroundColor: "white",
      color: "darkblue",
      subItems: [{ title: t.SPONSOR_LINK, url: "/sponsor" }],
    },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: vertical ? "column" : "row", // Verticale o orizzontale
          margin: !vertical && "5px 0",
          overflowX: vertical ? "hidden" : "auto", // Impostazioni overflow basate su `vertical`
        }}
      >
        {menuItems.map((menuItem, index) => (
          <div
            key={index}
            style={{
              flex: vertical ? "none" : "1 1 150px", // Disabilita `flex` in verticale
              margin: "5px",
              backgroundColor: "#E3E8EF",
              border: "2px solid #D8DEE9",
              borderRadius: "5px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height: "auto",
            }}
          >
            <div
              style={{
                color: "#1D3557",
                textAlign: "center",
                padding: "5px",
              }}
            >
              <strong>
                {menuItem.url ? (
                  <a href={menuItem.url} style={{ color: menuItem.color }}>
                    {menuItem.title}
                  </a>
                ) : (
                  <>{menuItem.title}</>
                )}
              </strong>
            </div>
            {vertical ? (
              <>
                {menuItem.subItems.map((subItem, subIndex) => (
                  <div
                    key={subIndex}
                    style={{
                      margin: "5px",
                      height: "100%",
                      overflow: "hidden", // Evita scrollbar
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "4px",
                    }}
                  >
                    <a
                      href={subItem.url}
                      style={{
                        boxShadow: "0 0 3px #003366",
                        fontSize: "clamp(0.6rem, 1.8vw, 0.95rem)", // 👈 Dinamico e responsive
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        textAlign: "center",
                        display: "block",
                        width: "100%", // 👈 Adatta all'intero contenitore
                      }}
                      className="menu-item-secondary"
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: subItem.title }}
                      />
                    </a>
                  </div>
                ))}
              </>
            ) : (
              <>
                {menuItem.subItems && (
                  <div
                    style={{
                      width: "100%",
                      padding: "5px",
                      alignContent: "center",
                    }}
                  >
                    {menuItem.subItems.map((subItem, subIndex) => (
                      <div
                        key={subIndex}
                        style={{ margin: "5px", overflowY: "auto" }}
                      >
                        <a
                          href={subItem.url}
                          style={{ boxShadow: "0 0 3px #003366" }}
                          className="menu-item-secondary"
                        >
                          <div
                            dangerouslySetInnerHTML={{ __html: subItem.title }}
                          />
                        </a>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default SecondaryMenu;
